import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
export const Panel = (props) => {
    var _a, _b;
    let paperSx = null;
    if (props.variant === 'level2' || props.variant === 'level3') {
        paperSx = {
            border: 'none',
            borderRadius: 0,
        };
    }
    const headerSx = {
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        alignItems: { sm: 'center' },
        p: { xs: 2, sm: 0 },
        pl: { sm: 2 },
        pr: { sm: 1.5 },
    };
    if ((_a = props.alert) === null || _a === void 0 ? void 0 : _a.severity) {
        headerSx.color = alertColorMap[props.alert.severity];
        headerSx.backgroundColor = alertBackgroundColorMap[props.alert.severity];
    }
    else if (props.variant === 'level2') {
        headerSx.backgroundColor = themeColors.surface.secondary;
    }
    else if (props.variant === 'level3') {
        headerSx.backgroundColor = themeColors.surface.tertiary;
    }
    const headerVariant = props.variant === 'level2' || props.variant === 'level3' ? 'subtitle2' : 'subtitle1';
    return (React.createElement(Paper, { variant: 'outlined', sx: paperSx },
        React.createElement(Box, { sx: headerSx },
            !props.alert && (React.createElement(Typography, { variant: headerVariant, sx: { flexGrow: { sm: 1 }, pt: { sm: 2 }, pb: { sm: 2 } } }, props.label)),
            props.alert && (props.alert.severity || props.alert.message) && (React.createElement(React.Fragment, null,
                React.createElement(Typography, { variant: headerVariant, sx: { width: { sm: '50%' }, pt: { sm: 2 }, pb: { xs: 1, sm: 2 } } }, props.label),
                React.createElement(Typography, { variant: headerVariant, sx: { flexGrow: { sm: 1 }, pl: { sm: '12px' }, pt: { sm: 2 }, pb: { sm: 2 } } },
                    props.alert.severity && alertIconMap[props.alert.severity],
                    ((_b = props.alert) === null || _b === void 0 ? void 0 : _b.message) && props.alert.message))),
            props.actions && props.actions),
        React.createElement(Box, { sx: { p: 2, pt: 0, backgroundColor: props.variant === 'level2' ? themeColors.surface.secondary : undefined } }, props.children)));
};
const alertColorMap = {
    info: themeColors.accent.blue.bold,
    error: themeColors.accent.red.bold,
    warning: themeColors.accent.orange.bold,
    success: themeColors.accent.green.bold,
};
const alertBackgroundColorMap = {
    info: themeColors.accent.blue.subtlest,
    error: themeColors.accent.red.subtlest,
    warning: themeColors.accent.orange.subtlest,
    success: themeColors.accent.green.subtlest,
};
const alertIconMap = {
    info: React.createElement(CheckCircleOutlinedIcon, { sx: { mr: 1, verticalAlign: 'middle' } }),
    error: React.createElement(ReportProblemOutlinedIcon, { sx: { mr: 1, verticalAlign: 'middle' } }),
    warning: React.createElement(ErrorOutlineIcon, { sx: { mr: 1, verticalAlign: 'middle' } }),
    success: React.createElement(InfoOutlinedIcon, { sx: { mr: 1, verticalAlign: 'middle' } }),
};
